import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {SupplierContactsPage} from "./-page/supplier-contacts.page";
import {SupplierContactsPending} from "./-page/supplier-contacts.pending";
import {supplierContactsSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/engineering/suppliers/$supplierId/contacts/")({
  component: RouteComponent,
  pendingComponent: SupplierContactsPending,
  staticData: {meta: {labelDescriptor: routeMessages.contacts}},
  validateSearch: (search) => supplierContactsSearchSchema.parse(search),
});

function RouteComponent() {
  const {supplierId} = useParams({strict: false}) as {supplierId: string};
  const {includeDeleted} = Route.useSearch();

  return <SupplierContactsPage supplierId={supplierId} includeDeleted={includeDeleted} />;
}
